import { useState } from "react";

const FooterLinkData = [
  {
    title: "PATIENTS",
    children: [
      {
        title: "Book a Test",
        url: "https://www.lalpathlabs.com/book-a-test/agra",
        newTab: false,
      },
      {
        title: "Nearest Centre",
        url: "https://www.lalpathlabs.com/lab/visit/agra",
        newTab: false,
      },
      {
        title: "Download Report",
        url: "https://www.lalpathlabs.com/download-report",
        newTab: false,
      },
      {
        title: "Download App",
        url: "https://www.lalpathlabs.com/download-app",
        newTab: false,
      },
      {
        title: "Promotions & Discounts",
        url: "https://www.lalpathlabs.com/special-offers",
        newTab: false,
      },
      {
        title: "Special Programs",
        url: "https://www.lalpathlabs.com/#patientspr",
        newTab: false,
      },
    ],
  },
  {
    title: "DOCTORS",
    children: [
      {
        title: "Test Menu",
        url: "https://www.lalpathlabs.com/test-menu/doctor",
        newTab: false,
      },
      {
        title: "Our Labs",
        url: "https://www.lalpathlabs.com/doctors/our-labs",
        newTab: false,
      },
      {
        title: "Events",
        url: "https://www.lalpathlabs.com/events",
        newTab: false,
      },
      {
        title: "Quality",
        url: "https://www.lalpathlabs.com/quality-and-accreditation",
        newTab: false,
      },
      {
        title: "Resource Center",
        url: "https://www.lalpathlabs.com/resource-centre",
        newTab: false,
      },
      {
        title: "Our Departments",
        url: "https://www.lalpathlabs.com/doctors#department",
        newTab: false,
      },
    ],
  },
  {
    title: "BUSINESS PARTNERSHIP",
    children: [
      {
        title: "Partner With Us",
        url: "https://www.lalpathlabs.com/business-partnership#Partner-with-us",
        newTab: false,
      },
      {
        title: "Become a Vendor",
        url: "https://www.lalpathlabs.com/business-partnership/vendor-registration",
        newTab: false,
      },
      {
        title: "Corporate Tie-up",
        url: "https://www.lalpathlabs.com/business-partnership/corporate-tie-up",
        newTab: false,
      },
      {
        title: "International Partnership",
        url: "https://www.lalpathlabs.com/business-partnership/international-partner",
        newTab: false,
      },
      { title: "Corporate Covid Testing", url: "/", newTab: false },
    ],
  },
  {
    title: "ABOUT US",
    children: [
      {
        title: "Our Journey",
        url: "https://www.lalpathlabs.com/about-us#ourjourney",
        newTab: false,
      },
      {
        title: "Vision, Mission & Values",
        url: "https://www.lalpathlabs.com/about-us#visionmission",
        newTab: false,
      },
      {
        title: "Our Team",
        url: "https://www.lalpathlabs.com/about-us#ourteam",
        newTab: false,
      },
      {
        title: "Our Network",
        url: "https://www.lalpathlabs.com/about-us#ournetwork",
        newTab: false,
      },
      {
        title: "Logistics Strength",
        url: "https://www.lalpathlabs.com/about-us#logisticsstrength",
        newTab: false,
      },
      {
        title: "CSR",
        url: "https://www.lalpathlabs.com/investors/investors-inside/annual-report",
        newTab: false,
      },
      {
        title: "Career",
        url: "https://www.lalpathlabs.com/investors/investors-inside/corporate-presentation",
        newTab: false,
      },
    ],
  },
  {
    title: "INVESTORS",
    children: [
      {
        title: "Financials",
        url: "https://www.lalpathlabs.com/investors/investors-inside/annual-report",
        newTab: false,
      },
      {
        title: "Investors Information",
        url: "https://www.lalpathlabs.com/investors/investors-inside/corporate-presentation",
        newTab: false,
      },
      {
        title: "Corporate Governance",
        url: "https://www.lalpathlabs.com/investors/investors-inside/board-of-directors",
        newTab: false,
      },
      { title: "Smart ODR", url: "https://smartodr.in/login", newTab: false },
    ],
  },
];

const Footer = () => {
  return (
    <footer
      className="position-relative w-100 mt-5"
      style={{
        background:
          "url(https://www.lalpathlabs.com/test/public//assets/img/bg/footer-bg.png) no-repeat center/cover",
      }}
    >
      <div className="container mt-5 pt-5">
        <div className="grid gap-5 sm:grid-cols-2 md:grid-cols-3 xl:grid-cols-5">
          {FooterLinkData.map((section) => (
            <div key={section.title}>
              <h5 className="footerHead font-semibold mb-3">{section.title}</h5>
              <ul className="list-unstyled">
                {section.children.map((link) => (
                  <li key={link.title} className="mb-2">
                    <a
                      href={link.url}
                      target={link.newTab ? "_blank" : "_self"}
                      className="text-decoration-none alink"
                    >
                      {link.title}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>

      <div
        className="text-center text-white py-4"
        style={{ backgroundColor: "#004C95" }}
      >
        <p className="mb-1">
          © {new Date().getFullYear()} Dr Lal PathLabs All Right Reserved.
          ---v2.06.09.25.3
        </p>
        <p className="mb-2">
          <a
            href="https://www.lalpathlabs.com/blog"
            className="text-decoration-none text-white"
          >
            Blog
          </a>{" "}
          &nbsp;|&nbsp;
          <a
            href="https://www.lalpathlabs.com/csr"
            className="text-decoration-none text-white"
          >
            CSR
          </a>{" "}
          &nbsp;|&nbsp;
          <a
            href="https://www.lalpathlabs.com/term-of-use"
            className="text-decoration-none text-white"
          >
            Terms of Use
          </a>{" "}
          &nbsp;|&nbsp;
          <a
            href="https://www.lalpathlabs.com/privacy-policy"
            className="text-decoration-none text-white"
          >
            Privacy Policy
          </a>{" "}
          &nbsp;|&nbsp;
          <a
            href="https://www.lalpathlabs.com/onlinecancellationpolicy"
            className="text-decoration-none text-white"
          >
            Cancellation Policy
          </a>{" "}
          &nbsp;|&nbsp;
          <a
            href="https://www.lalpathlabs.com/cookie-policy"
            className="text-decoration-none text-white"
          >
            Cookie Policy
          </a>{" "}
          &nbsp;|&nbsp;
          <a
            href="https://www.lalpathlabs.com/sitemap"
            className="text-decoration-none text-white"
          >
            Sitemap
          </a>
        </p>
        <div className="d-flex justify-content-center align-items-center gap-2 flex-wrap">
          <span>Follow us on:</span>
          <a
            href="https://twitter.com/lalpathlabs"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img
              src="https://media.lalpathlabs.com/media/icons/footer-icon/twitter-footer.webp"
              alt="Twitter"
              width={25}
              height={25}
            />
          </a>
          <a
            href="https://www.facebook.com/lalpathlabs"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img
              src="https://media.lalpathlabs.com/media/icons/footer-icon/facebook-footer.webp"
              alt="Facebook"
              width={25}
              height={25}
            />
          </a>
          <a
            href="https://www.linkedin.com/company/dr-lal-pathlabs/"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img
              src="https://media.lalpathlabs.com/media/icons/footer-icon/linkdn-footer.webp"
              alt="LinkedIn"
              width={25}
              height={25}
            />
          </a>
          <a
            href="https://www.youtube.com/channel/UC9GNDaSo86RbFvY9TqofaBA"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img
              src="https://media.lalpathlabs.com/media/icons/footer-icon/youtube-footer.webp"
              alt="YouTube"
              width={25}
              height={25}
            />
          </a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
